// extracted by mini-css-extract-plugin
module.exports =  {"validation":"Validation-module__validation___Ggqwv","errors":"Validation-module__errors___yB6Gh"};